import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Blase } from "./Blase";
import { hinweisPraesenzMerken } from "./einstellungen";
import { PRAESENZ_HINWEIS } from "./saetze";

/** Präsenz-Hinweis (E13): zweite Blase des Geists mit „Geist einstellen“ (öffnet die Einstellungen an der Auswahl „Geist“)
 *  und „Verstanden“. Steht nur an einer Figur (Sprecher-Regel: in einer Geist-Szene oder der Einführung, Web-4); der
 *  Merker `pg-hinweis-praesenz` wird gesetzt, sobald die Blase erscheint. Ob sie erscheint (nur bei „Überall“, ohne
 *  Merker), entscheidet der Aufrufer. */
export function PraesenzHinweis(props: { onVerstanden: () => void }) {
  const navigieren = useNavigate();
  useEffect(() => hinweisPraesenzMerken(), []);
  return (
    <Blase form="kopf" satz={PRAESENZ_HINWEIS.satz} label="Hinweis des Briefgeists" className="praesenz-hinweis">
      <div className="blase-knoepfe">
        <button type="button" className="knopf" data-art="sekundaer" data-klein="" onClick={() => void navigieren("/einstellungen/darstellung#geist")}>
          {PRAESENZ_HINWEIS.einstellen}
        </button>
        <button type="button" className="knopf" data-art="primaer" data-klein="" onClick={props.onVerstanden}>
          {PRAESENZ_HINWEIS.verstanden}
        </button>
      </div>
    </Blase>
  );
}
